module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "anthony_hs.1d7f090e.jpg";